import { useNavigate } from 'react-router-dom';
import { LogoLoader } from '@gokrew/ui';
import { AuthV2Layout } from '../components/AuthV2Layout';
import { SelectCompanyPage } from './SelectCompanyPage';
import { useAuth } from '@/context/AuthContext';
import { OnboardingRoute } from '@gokrew/models/onboarding';
import layoutStyles from '../components/AuthV2Layout.module.css';
import type { Company } from '@/types/company';

export function SelectWorkspacePage() {
  const navigate = useNavigate();
  const { companies, isLoading, setHasCompany, changeCompany } = useAuth();

  function handleSelectCompany(company: Company) {
    changeCompany(company);
    setHasCompany(true);
    navigate('/dashboard', { replace: true });
  }

  return (
    <AuthV2Layout>
      <div className={layoutStyles.formInner}>
        <div className={layoutStyles.formCard}>
          {isLoading ? (
            <LogoLoader />
          ) : (
            <SelectCompanyPage
              companies={companies ?? []}
              onSelectCompany={handleSelectCompany}
              onNewCompany={() => navigate(OnboardingRoute.Company)}
            />
          )}
        </div>
      </div>
    </AuthV2Layout>
  );
}
